import { useInfiniteQuery } from '@tanstack/react-query';
import { api } from '../services/authService';

interface GetCurrenciesParams {
  search?: string;
}

const useGetCurrencies = (params: GetCurrenciesParams = {}) => {
  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    status,
    isError,
    refetch,
    isPending,
  } = useInfiniteQuery({
    queryKey: ['currencies', params],
    queryFn: async ({ pageParam = '' }) => {
      let url = '/admin/currencies';
      const searchParams = new URLSearchParams();
      if (params.search) searchParams.append('code', params.search);
      if (pageParam) searchParams.append('next_cursor', pageParam);
      if (searchParams.toString()) url += `?${searchParams.toString()}`;
      
      const response = await api.get(url);
      return {
        currencies: response.data.currencies || [],
        next_cursor: response.data.next_cursor,
      };
    },
    getNextPageParam: (lastPage) => lastPage?.next_cursor,
    initialPageParam: '',
    select: (data) => ({
      currencies: data?.pages.flatMap((page) => page?.currencies) || [],
      next_cursor: data?.pages[data.pages.length - 1]?.next_cursor,
    }),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
  });

  return {
    data: data?.currencies || [],
    nextCursor: data?.next_cursor,
    error,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    isLoading: isFetching,
    status,
    isError,
    refetch,
    isPending,
  };
};

export default useGetCurrencies; 